module.exports = __webpack_public_path__ + "static/skyscraper-Banner-2-2758485cc4b654d17a48256c3a33bd16.jpg";